export default __webpack_public_path__ + "static/media/white-close.e196cbd8.svg";